<!-- <div class="header"></div> -->
<div class="site-container">
  <app-ui-layout-header></app-ui-layout-header>
  <div class="appeal-form-content" [formGroup]="angForm" novalidate>
    <div class="person-information">
      <div class="form-box">
        <div class="form-head">Kişisel Bilgiler</div>
        <div class="form-content">
          <div class="form-group">
            <label for="ad">Ad <span>*</span></label>
            <input #name id="name" name="name" type="text" formControlName="name" required>
          </div>
          <div class="form-group">
            <div
              *ngIf="angForm.controls['name'].invalid && (angForm.controls['name'].dirty || angForm.controls['name'].touched)"
              class="alert alert-danger">
              <div *ngIf="angForm.controls['name'].errors.required">
                Ad alanı zorunludur.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="soyad">Soyad <span>*</span></label>
            <input #surname id="surname" name="surname" type="text" formControlName="surname" required>
          </div>
          <div class="form-group">
            <div
              *ngIf="angForm.controls['surname'].invalid && (angForm.controls['surname'].dirty || angForm.controls['surname'].touched)"
              class="alert alert-danger">
              <div *ngIf="angForm.controls['surname'].errors.required">
                Soyad alanı zorunludur.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="dogum-tarihi">Doğum Tarihi <span>*</span></label>
            <input #birthdate id="dogum-tarihi" name="dogum-tarihi" type="date" formControlName="birthdate" required>
          </div>
          <div class="form-group">
            <div
              *ngIf="angForm.controls['birthdate'].invalid && (angForm.controls['birthdate'].dirty || angForm.controls['birthdate'].touched)"
              class="alert alert-danger">
              <div *ngIf="angForm.controls['birthdate'].errors.required">
                Doğum tarihi alanı zorunludur.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="email">E-Posta <span>*</span></label>
            <input #email id="email" name="email" type="text" formControlName="email" required>
          </div>
          <div class="form-group">
            <div
              *ngIf="angForm.controls['email'].invalid && (angForm.controls['email'].dirty || angForm.controls['email'].touched)"
              class="alert alert-danger">
              <div *ngIf="angForm.controls['email'].errors.required">
                Email alanı zorunludur.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="telefon1">Telefon Numarası <span>*</span></label>
            <input #telefon1 id="telefon1" name="telefon1" type="text" formControlName="telefon1" required>
          </div>
          <div class="form-group">
            <div
              *ngIf="angForm.controls['telefon1'].invalid && (angForm.controls['telefon1'].dirty || angForm.controls['telefon1'].touched)"
              class="alert alert-danger">
              <div *ngIf="angForm.controls['telefon1'].errors.required">
                Telefon alanı zorunludur.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="web-sitesi">Web Adresi</label>
            <input #website id="web-sitesi" name="web-sitesi" type="text">
          </div>
          <div class="form-group">
            <label for="adres">Adres <span>*</span></label>
            <textarea #address id="adres" name="adres"></textarea>
          </div>
          <div class="form-group">
            <label for="katildigi-sergiler">Katıldığı Sergiler</label>
            <textarea #attendedexhibitions id="katildigi-sergiler" name="katildigi-sergiler"></textarea>
          </div>

        </div>
      </div>
    </div>
    <div class="title-box">
      <div class="title-information">
        <div class="form-box">
          <div class="form-head title-head"> Eser Bilgileri</div>

          <div class="form-content">
            <div class="form-group">
              <label for="eseradi">Eser Adı <span>*</span></label>
              <input #sculpturename id="eseradi" name="eseradi" type="text" formControlName="eseradi" required>
            </div>
            <div class="form-group">
              <div
                *ngIf="angForm.controls['eseradi'].invalid && (angForm.controls['eseradi'].dirty || angForm.controls['eseradi'].touched)"
                class="alert alert-danger">
                <div *ngIf="angForm.controls['eseradi'].errors.required">
                  Eser adı alanı zorunludur.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="uretim-tarihi">Üretim Tarihi </label>
              <input #productiondate id="uretim-tarihi" name="uretim-tarihi" type="date">
            </div>
            <div class="form-group">
              <label for="en">En <span>*</span></label>
              <input #width id="en" name="en" type="number" formControlName="en" required>
            </div>
            <div class="form-group">
              <div
                *ngIf="angForm.controls['en'].invalid && (angForm.controls['en'].dirty || angForm.controls['en'].touched)"
                class="alert alert-danger">
                <div *ngIf="angForm.controls['en'].errors.required">
                  En alanı zorunludur.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="boy">Boy <span>*</span></label>
              <input #height id="boy" name="boy" type="number" formControlName="boy" required>
            </div>
            <div class="form-group">
              <div
                *ngIf="angForm.controls['boy'].invalid && (angForm.controls['boy'].dirty || angForm.controls['boy'].touched)"
                class="alert alert-danger">
                <div *ngIf="angForm.controls['boy'].errors.required">
                  Boy alanı zorunludur.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="derinlik">Derinlik <span>*</span></label>
              <input #depth id="derinlik" name="derinlik" type="number" formControlName="derinlik" required>
            </div>
            <div class="form-group">
              <div
                *ngIf="angForm.controls['derinlik'].invalid && (angForm.controls['derinlik'].dirty || angForm.controls['derinlik'].touched)"
                class="alert alert-danger">
                <div *ngIf="angForm.controls['derinlik'].errors.required">
                  Derinlik alanı zorunludur.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="malzeme">Malzeme <span>*</span></label>
              <input #material id="malzeme" name="malzeme" type="text" formControlName="malzeme" required>
            </div>
            <div class="form-group">
              <div
                *ngIf="angForm.controls['malzeme'].invalid && (angForm.controls['malzeme'].dirty || angForm.controls['malzeme'].touched)"
                class="alert alert-danger">
                <div *ngIf="angForm.controls['malzeme'].errors.required">
                  Malzeme alanı zorunludur.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="agirlik">Ağırlık <span>*</span></label>
              <input #weight id="agirlik" name="agirlik" type="text" formControlName="agirlik" required>
            </div>
            <div class="form-group">
              <div
                *ngIf="angForm.controls['agirlik'].invalid && (angForm.controls['agirlik'].dirty || angForm.controls['agirlik'].touched)"
                class="alert alert-danger">
                <div *ngIf="angForm.controls['agirlik'].errors.required">
                  Ağırlık alanı zorunludur.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="kavramsal-tanim">Kavramsal Tanım <span>*</span></label>
              <textarea #definiton id="definiton" name="definiton"></textarea>
            </div>
            <div class="image-input-content">
              <div class="form-head">Eser Görselleri</div>
              <div class="form-explain">( <span>Adet : <b>1-5</b></span> |
                <span>Ebat : <b>1000px x 667px</b></span> | <span>Size : <b>Max 10 MB</b></span> | <span>Format :
                  <b>.jpg ve .png</b></span>)
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-3"><label>Görsel 1 <span>*</span><br><span style="font-size: 9px;">(Anahtar görsel olarak kullanılacaktır.)</span></label></div>
                <div class="col-md-9">
                  <app-upload (onUploadFinished)="uploadFinished1($event)" yuklemeTipi="Foto"></app-upload>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">

                <div class="col-md-3"><label>Görsel 2</label></div>
                <div class="col-md-9">
                  <app-upload (onUploadFinished)="uploadFinished2($event)" yuklemeTipi="Foto"></app-upload>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">

                <div class="col-md-3"><label>Görsel 3</label></div>
                <div class="col-md-9">
                  <app-upload (onUploadFinished)="uploadFinished3($event)" yuklemeTipi="Foto"></app-upload>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">

                <div class="col-md-3"><label>Görsel 4</label></div>
                <div class="col-md-9">
                  <app-upload (onUploadFinished)="uploadFinished4($event)" yuklemeTipi="Foto"></app-upload>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">

                <div class="col-md-3"><label>Görsel 5</label></div>
                <div class="col-md-9">
                  <app-upload (onUploadFinished)="uploadFinished5($event)" yuklemeTipi="Foto"></app-upload>
                </div>
              </div>
            </div>
            <div class="video-input-content">
              <div class="form-head">Eser Videosu</div>
              <div class="form-explain">(<span>Adet : <b>1</b> </span> | <span>Oran : <b>4:3</b></span> |
                <span>Süre: <b>Max 2 dk</b></span> | <span>Size: <b>Max 50 MB</b></span> | <span>Format :
                  <b>.mp4</b></span>)
              </div>
            </div>
            <div class="form-group">
              <div class="row">

                <div class="col-md-3"><label>Video <span>*</span></label></div>
                <div class="col-md-9">
                  <app-upload (onUploadFinished)="uploadFinishedVideo($event)" yuklemeTipi="Video"></app-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-checkbox-content">
      <div class="form-checkbox-head">
        Eser ekleme işlemini bitirdiyseniz başvuruyu tamamlayabilirsiniz.
      </div>
      <div class="label-list">
        <label class="client-form-checkbox">
          <input aria-checked="false" #basvurukosullari class="option-input checkbox" type="checkbox"
            (change)="handleSelectedBasvuru($event)">
          <span>
            <a href="/basvuru-yonetmelik" target="_blank">Başvuru Koşulları ve Yarışma Yönetmeliği</a>'ni okudum ve
            onaylıyorum.
          </span>
        </label>
        <label class="client-form-checkbox">
          <input aria-checked="false" #isDisplay class="option-input checkbox" role="checkbox" tabindex="0"
            (change)="handleSelectedKvkk($event)" type="checkbox">
          <span> Veri sorumlusu Milliyet Gazetecilik ve Yayıncılık A.Ş.(“Milliyet”) tarafından işbu başvuru formu
            aracılığıyla paylaşmış olduğunuz kişisel verileriniz, Heykelde Yeni Keşifler yarışma başvurularının
            değerlendirilmesi amacıyla işlenecektir. Detaylı aydınlatma metni için <a
              href="/kvkk">tıklayınız</a>.</span>
        </label>
      </div>
    </div>
    <!-- <div class="form-button submit-button" *ngIf="showMeKvkk && showMeBasvuru"> -->
    <div class="form-button submit-button">
      <a (click)="applyForm(name.value,surname.value,email.value,birthdate.value,telefon1.value,website.value, address.value,
         attendedexhibitions.value, sculpturename.value,productiondate.value, width.value, height.value, depth.value, material.value, weight.value,
          definiton.value);">
        <i class="check-icon"></i>
        <span>Başvuruyu Tamamla</span>
      </a>
    </div>
    <div class="input-error-message" *ngIf="showFormEksikAlan">
      Başvurunuzu eksiksiz olarak tamamlayabilmeniz için zorunlu alanları doldurmalısınız!
    </div>
    <div class="input-error-message" *ngIf="showVideoVeGorselZorunlu">
      Başvurunuzu eksiksiz olarak tamamlayabilmeniz için en az bir adet görsel ve video yüklemeniz gerekmektedir.
    </div>
    <div class="input-error-message" *ngIf="showMeCheckBoxlar">
      Başvurunuzu eksiksiz olarak tamamlayabilmeniz için KVKK ve Başvuru Koşulları ve Yarışma Yönetmeliğini kabul
      etmeniz gerekmektedir.
    </div>
    <div class="input-error-message" *ngIf="showMeBirHataOlustu">
      Başvurunuz esnasında bir hata oluştu. Lütfen giriş yapılan alanları kontrol ediniz.
    </div>
  </div>
</div>
<!-- <p>Form value: {{ angForm.value | json }}</p> -->
<!-- <div class="footer">
</div> -->